import * as _ from 'lodash';

/**
 * Helper class for checking user permissions/rights
 */
export class PermissionHelper {
  /**
   * Checks if a user has a specific right/permission
   * @param user - The user object containing the right property
   * @param right - The right/permission number to check for
   * @returns true if the user has the specified right, false otherwise
   */
  static hasRight(user: any, right: number): boolean {
    // SuperUsers have all rights
    if (user && user.isSuperUser === "true") {
      return true;
    }
    
    return (
      user &&
      user.right &&
      ((_.isArray(user.right) && user.right.indexOf(right.toString()) >= 0) || user.right === right.toString())
    );
  }

  /**
   * Checks if a user has any of the specified rights/permissions
   * @param user - The user object containing the right property
   * @param rights - Array of right/permission numbers to check for
   * @returns true if the user has at least one of the specified rights, false otherwise
   */
  static hasAnyRight(user: any, rights: number[]): boolean {
    // SuperUsers have all rights
    if (user && user.isSuperUser === "true") {
      return true;
    }
    
    return (
      user &&
      user.right &&
      _.isArray(rights) &&
      !!rights.find(right => PermissionHelper.hasRight(user, right))
    );
  }
}
